import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, Card, Table, Form, message, Input } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import { req_list_oss_tag, req_del_oss_tag, req_add_oss_tag } from '../../api'

class OneConsultingKeywordsModal extends Component {
    // 基礎通用參數 //////////////////////////////////////////////    
    static propTypes = {
        item: PropTypes.object.isRequired
    }
    state = {
        items: [],
        loading: false,
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_list_items()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_items = async () => {
        const { token } = this.props.user
        const { nidConsulting } = this.props.item
        this.setState({ loading: true })
        const result = await req_list_oss_tag(nidConsulting, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result !== null) {
            const items = result
            this.setState({ items })
        } else {
            this.setState({ items: [] })
        }
    }

    api_delete_item = async (key) => {
        const { token } = this.props.user
        const result = await req_del_oss_tag(key, token)

        if (result.status === 'success') {
            message.success('刪除成功')
            this.api_list_items()
        } else {
            //console.log(result)
        }
    }

    api_add_item = async (row) => {
        const token = this.props.user.token
        //console.log(row)
        const result = await req_add_oss_tag(row, token)
        if (result.status === 'success') {
            // 1 結果提示
            message.success('新增成功')
            this.api_list_items()
        } else {
            //console.log(result)
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    init_columns = () => {
        this.columns = [
            {
                title: '關鍵字',
                dataIndex: 'tagContent',
                width: 150,
                render: (field) => {
                    return (
                        <div>
                            <span style={{ fontSize: '1.3em' }}> {field}</span>
                        </div>
                    )
                },
            }, {
                title: '操作',
                width: 50,
                fixed: 'right',
                render: (item) => {
                    return (
                        <span>
                            <Button type='dashed' size='small' style={{ color: 'Block' }} onClick={() => this.handle_delete_item(item)}><i className="fas fa-minus" style={{ marginRight: '4px' }}></i> 刪除</Button>
                        </span>
                    )
                }
            },
        ]
    }

    // 操作互動處理 //////////////////////////////////////////////
    // 刪除
    handle_delete_item = (item) => {
        const { gid } = item
        Modal.confirm({
            title: '注意',
            icon: <ExclamationCircleOutlined />,
            content: '確認要刪除此關鍵字!',
            okText: '確認',
            cancelText: '取消',
            onOk: () => {
                this.api_delete_item(gid)
            },
        });
    }

    handle_add_item = (values) => {
        //console.log('Success:', values);
        const { nidConsulting } = this.props.item
        const { tagContent } = values

        const item = {
            nidConsulting: nidConsulting,
            tagContent: tagContent,
        }
        this.api_add_item(item)
    };

    onFinishFailed = (errorInfo) => {
        //console.log('Failed:', errorInfo);
      };

    render() {
        const { loading, items } = this.state
        const title = (
            <>
                <Form
                layout={'inline'}
                    onFinish={this.handle_add_item}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        label="關鍵字"
                        name="tagContent"
                        rules={[
                            { required: true, whitespace: true, message: '必須填寫關鍵字' },
                        ]}
                    >
                        <Input placeholder="輸入關鍵字" />
                    </Form.Item>
                    <Form.Item>
                        <Button type='primary' htmlType="submit"><i className="fas fa-plus" style={{ marginRight: '4px' }}></i> 增加</Button>
                    </Form.Item>
                </Form>
            </>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 400 }}
                    loading={loading}
                    rowKey='gid'
                    dataSource={items}
                    columns={this.columns}
                    pagination={false}
                />
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(OneConsultingKeywordsModal)